import React, { Component } from 'react';
import './reward.scss';

import Loading from '../common/loading/loading';
import { ImageConstants } from '../../constants/constants';
import ToasterComponent from '../common/cw-toaster-component/cw-toaster-component';
import { getImageSource } from '../../utility/image-source'
import RedeemInfo from "./info/info"
import Redeem from "./redeem/redeem"
import RedeemedVouchers from "./redeemed-vouchers/redeemed-vouchers"
import AnimatedNumber from "animated-number-react";
import { Modal, ModalBody } from "reactstrap";
import RewardApi from '../../apis/rewards'
import CommonUtils from '../../utility/common-utilities';
import PaginationComponent from '../common/cw-pagination/cw-pagination-v2';


class Rewards extends Component {
    state = {
        loading: false,
        records: []
    }
    page = 1
    limit = 10

    typeText = {
        "HOMEWORK_ASSIGN": "Assigned Homework",
        "CLASSWORK_ASSIGN": "Assigned Classwork",
        "ASSESSMENT_ASSIGN": "Assigned Assessment",
        "CLASSWORK_ASSESSMENT_ASSIGN" : 'Assigned Classwork Assessment',
        "ADAPTIVE_CLASSWORK_ASSIGN" : "Assigned Personalised Classwork",
        "ADAPTIVE_HOMEWORK_ASSIGN" : 'Assigned Personalised Homework',
        "HOMEWORK_COMPLETION": "Homework Completion",
        "CLASSWORK_COMPLETION": "Classwork Completion",
        "ADAPTIVE_CLASSWORK_COMPLETION" : "Personalised Classwork Completion",
        "ADAPTIVE_HOMEWORK_COMPLETION" : 'Personalised Homework Completion',
        "ASSESSMENT_COMPLETION": "Assessment Completion",
        "CLASSWORK_ASSESSMENT_COMPLETION" : 'Classwork Assessment Completion',
        "SUBSCRIPTION": "Subscription",
        "WATCHED_VIDEO_ASSIGN" : 'Watched Learning Video',
        "CASE_STUDY_ASSIGN" : "Learned Chapter Case Study",
        "CHAPTER_ACTIVITY_ASSIGN" : "Learned Chapter Activity",

    }

    componentDidMount() {
        this.getReward()
        this.getRewardHistories()
    }

    getReward(payload = {}) {
        this.setState({ isLoading: true })
        RewardApi.getRewardPoints(payload)
            .then(response => {
                let reward = response.response
                this.setState({ reward: reward, isLoading: false })
            }).catch(err => {
                this.setState({ isLoading: false })
            })
    }

    getRewardHistories(payload = {}) {

        if (!payload.page) payload.page = this.page

        payload.limit = this.limit


        this.currentPage = payload.page

        this.setState({ isLoading: true })
        RewardApi.getRewardPointsActivity(payload)
            .then(response => {
                let records = response.response
                records = this.buildRecords(records)
                this.setState({ records, meta: response.meta || {}, isLoading: false })
            }).catch(err => {
                this.setState({ isLoading: false })
            })
    }

    onPageSelected = (selectedPage, startIndex) => {
        this.startIndex = startIndex
        this.page = selectedPage
        this.getRewardHistories()
    }

    buildRecords(records) {
        let result = []
        records.forEach(element => {
            let [i, ...arr] = new Date(element.countingwellCreatedTimestamp).toDateString().split(" ")

            let obj = {
                date: arr.join(" "),
                name : element.teacherName ? element.teacherName.trim() : element.studentName.trim(),
                source: this.typeText[element.type],
                class: `${element.class} ${element.section ? `- ${element.section}` : ""}`,
                point: element.point
            }
            result.push(obj)

        });

        return result
    }

    showToaster(type, message) {
        this.setState({
            showToaster: true,
            toasterMessage: message,
            toasterType: type
        }, () => {
            setTimeout(() => { this.hideToaster() }, 3000);
        });
    }

    hideToaster() {
        this.setState({
            showToaster: false
        });
    }

    onClickInfo = (v, earn) => {
        // console.log(earn)

        if(earn) {
        this.setState({ showEarnInfo: !this.state.showEarnInfo })
        } 
        else {
        this.setState({ showRedeemInfo: !this.state.showRedeemInfo })
        }

    }

    renderRedeemInfo(type) {

        if(type === "EARN") {
            return (
                <Modal className="cw-custom-modal-right" isOpen={true} toggle={this.onClickInfo} size={'lg'}>
                    <ModalBody >
                        <RedeemInfo back={e => this.onClickInfo(e, "EARN")} type = {type}/>
                    </ModalBody>
                </Modal>
            )
        }
        else {
            return (
                <Modal className="cw-custom-modal-right" isOpen={true} toggle={this.onClickInfo} size={'lg'}>
                    <ModalBody >
                        <RedeemInfo back={this.onClickInfo} />
                    </ModalBody>
                </Modal>
            )
        }
    }

    showRedeem = (refetch) => {

        if (refetch) this.getReward()
        this.setState({ showRedeem: !this.state.showRedeem })
    }

    showRedeemedVoucher = () => {
        this.setState({ showRedeemedVoucher: !this.state.showRedeemedVoucher })
    }

    renderHeader() {
        return (

            <div className="row">
                <div className="col"><img className='back-icon cursor-pointer' alt="" src={getImageSource(ImageConstants.BACK_ICON)} onClick={this.props.back} /></div>
                <div className="col text-right">
                    <button className='cw-btn-md d-inline-block cw-btn-blue  mr-2' onClick={this.showRedeemedVoucher} >
                        VOUCHERS REDEEMED
                    </button>
                    <button className='cw-btn-md cw-btn-primary' onClick={this.showRedeem} >
                        REDEEM POINTS
                    </button>
                </div>
            </div>
        )
    }

    formatValue = (value) => value.toFixed(0)

    renderPointCard() {
        return (
            <div className="">
                <div className="row">
                    <div className="col-7 cw-card grad-blue position-relative">
                        {/* <div className="amt"><img alt="" className="icon-20 mr-2" src={getImageSource(ImageConstants.CURRENCY)} />You have earned ₹{CommonUtils.convertToFixed(this.state.reward?.amount || 0, 2)} </div> */}
                        <div className="row no-gutters">

                            <div className="col-4">
                                <div className="point-card p-2">
                                    <div>
                                        <div className="col my-auto point text-center">
                                            <img alt="" className="icon-40 mr-2" src={getImageSource(ImageConstants.REWARD1)} />
                                            <AnimatedNumber value={this.state.reward?.availablePoints || 0} formatValue={this.formatValue} />
                                        </div>
                                        <div className="point-title text-center">REWARD POINTS AVAILABLE</div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-8">
                                <div className="brand-wrapper">
                                    <div className="">
                                        <div className="">Redeem For: </div>
                                        <div>
                                            <div className="d-inline-block m-2" >
                                                <div className="cw-card offer-card p-2 bg-purble">
                                                    <img alt="" className="icon-40 mr-2" src={getImageSource(ImageConstants.FLIPKART)} />
                                                    <span className="offer-title">Flipkart Vouchers</span>
                                                </div>
                                            </div>

                                            <div className="d-inline-block m-2" >
                                                <div className="cw-card offer-card p-2 bg-orange">
                                                    <img alt="" className="icon-40 mr-2" src={getImageSource(ImageConstants.AMAZON)} />
                                                    <span className="offer-title">Amazon Vouchers</span>
                                                </div>
                                            </div>

                                            {/* <div className="d-inline-block m-2" >
                                                <div className="cw-card offer-card p-2 bg-blue">
                                                    <img alt="" className="icon-40 mr-2" src={getImageSource(ImageConstants.CROMA)} />
                                                    <span className="offer-title">Croma Vouchers</span>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="cw-card point-card grad-yellow p-2">
                            <div>
                                <div className="col my-auto point text-center">
                                    <img alt="" className="icon-40 mr-2" src={getImageSource(ImageConstants.REWARD2)} />
                                    <AnimatedNumber value={this.state.reward?.totalPoints || 0} formatValue={this.formatValue} />
                                </div>
                                <div className="point-title text-center">REWARDS POINTS EARNED TILL DATE</div>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="cw-card point-card grad-orange p-2">
                            <div>
                                <div className="col my-auto point text-center">
                                    <img alt="" className="icon-40 mr-2" src={getImageSource(ImageConstants.REWARD3)} />
                                    <AnimatedNumber value={this.state.reward?.usedPoints || 0} formatValue={this.formatValue} />
                                </div>
                                <div className="point-title text-center">REWARD POINTS REDEEMED</div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }

    renderRecords() {
        return (
            <div className="pt-4">

                <div className="">
                    <span className="header-text">Point Records </span>
                    <span className="float-right cursor-pointer" onClick={this.onClickInfo}>
                        How to redeem reward points?
                    </span>
                    <span className="float-right cursor-pointer mr-3" onClick={(e) => this.onClickInfo(e,"EARN")}>
                        <img alt="" className="info-icon mr-1" src={getImageSource(ImageConstants.INFO)} />
                        How to earn reward points?
                    </span>
                </div>

                <div className="pt-2">
                    <div id="table-scoll" className="table-responsive mt-1">
                        <table className="table cw-table">
                            <thead>
                                <tr>
                                    <th className='th-left-radius'>Date</th>
                                    <th>Name</th>
                                    <th>Source</th>
                                    <th>Class</th>
                                    <th className='th-right-radius'>Points</th>

                                </tr>
                            </thead>
                            <tbody className="bg-white">
                                {
                                    this.state.records?.length ? this.state.records?.map(item => (
                                        <tr>
                                            <td>{item.date}</td>
                                            <td>{item.name}</td>
                                            <td>{item.source}</td>
                                            <td>{item.class}</td>
                                            <td>{CommonUtils.convertToFixed(item.point, 2)}</td>
                                        </tr>
                                    ))
                                        :

                                        <tr>
                                            <td colSpan="5" align='center'> No Records Found</td>
                                        </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='card-footer'>
                    {
                        this.state.meta?.totalPages ?
                            <PaginationComponent startIndex={this.startIndex} selectedPage={this.currentPage} totalPages={this.state.meta?.totalPages} onPageSelected={this.onPageSelected} /> : ''
                    }
                </div>
            </div>
        )
    }

    render() {

        if (this.state.showRedeem) return <Redeem reward={this.state.reward} back={this.showRedeem} />
        if (this.state.showRedeemedVoucher) return <RedeemedVouchers back={this.showRedeemedVoucher} />

        return (
            <div className="reward">
                {this.state.loading && <Loading />}

                <div>
                    {this.renderHeader()}
                </div>

                <div className="pt-4">
                    <span className='screen-title'>Rewards Points</span>
                </div>

                <div className="pt-4">
                    {this.renderPointCard()}
                </div>

                <div className="pt-4">
                    {this.renderRecords()}
                </div>
                {
                    this.state.showRedeemInfo ? this.renderRedeemInfo() : ""
                }
                {
                    this.state.showEarnInfo ? this.renderRedeemInfo("EARN") : ""
                }
                {this.state.showToaster ? <ToasterComponent message={this.state.toasterMessage} type={this.state.toasterType} /> : ""}
            </div>);
    }
}

export default Rewards;